import { v4 } from 'uuid';

export function randomPassConfirm(len: number, charSet?: string) {
    charSet = charSet || 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
    var randomString = '';
    for (var i = 0; i < len; i++) {
        var randomPoz = Math.floor(Math.random() * charSet.length);
        randomString += charSet.substring(randomPoz, randomPoz + 1);
    }
    return randomString;
}
export function randomBoolean() {
    return Math.random() < 0.5;
}
export function randomNumber(min: number = 0, max: number = 100) {
    // min and max included
    return Math.floor(Math.random() * (max - min + 1) + min);
}
export function randomDateISOStr(min: number = 0, max: number = 100) {
    return new Date().toISOString();
}
export function randomPercentage(min: number = 0, max: number = 100) {
    return Math.floor(Math.random() * 100) + 1 + '%';
}

export function dynamicSort<T>(sort: string) {
    const propertyAndOrder = sort.split(' ');
    const property = propertyAndOrder[0] as keyof T;
    const sortOrder =
        propertyAndOrder.length === 2
            ? propertyAndOrder[1].trim().toLowerCase().includes('desc')
                ? -1
                : 1
            : 1;

    return function (a: T, b: T) {
        /* next line works with strings and numbers,
         * and you may want to customize it to your needs
         */

        const result =
            a[property] === undefined || a[property] === null
                ? -1
                : b[property] === undefined || b[property] === null
                  ? 1
                  : a[property] < b[property]
                    ? -1
                    : a[property] > b[property]
                      ? 1
                      : 0;
        return result * sortOrder;
    };
}

export function dynamicSortMultiple<T>(sorts: string) {
    const orderByDetail = sorts.split(',');
    /*
     * save the arguments object as it will be overwritten
     * note that arguments object is an array-like object
     * consisting of the names of the properties to sort by
     */
    return function (obj1: T, obj2: T) {
        let i = 0;
        let result = 0;
        /* try getting a different result from 0 (equal)
         * as long as we have extra properties to compare
         */
        while (result === 0 && i < orderByDetail.length) {
            result = dynamicSort(orderByDetail[i])(obj1, obj2);
            i++;
        }
        return result;
    };
}

export function downloadURI(uri: string, name: string) {
    const link = document.createElement('a');
    link.download = name;
    link.href = uri;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}
/**
 * convert link if it haven't https
 * @param link link need convert
 * @param isHttp if link is http
 * @returns https/http link
 */
export function convertToLinkIfNeed(link: string, isHttp?: boolean) {
    let genLink: string;

    if (link.split(',').length > 1) {
        genLink = link.split(',')[0];
    } else genLink = link;

    if (
        genLink.startsWith('https://') ||
        genLink.startsWith('http://') ||
        genLink.startsWith('blob')
    ) {
        return genLink;
    }
    return isHttp ? `http://${genLink}` : `https://${genLink}`;
}

export function randomID() {
    return v4();
}
